<template>
	<div>

		<div class="carbg">
			<div class="carline">
				<div class="carlinetitle">
					<span>{{titleTime}}</span>
					<span> {{$t('carline.carline_1')}}</span>
				</div>
				<div class="carlinet">
					<p>{{$t('carline.carline_2')}}</p>
				</div>
				<div class="carlineitem clearfix">
					<div class="carlinelist" v-for="(item,index) in carlist" :key="index">
						<div @click="CarLineDetail(item.MDTMDHID,item.MDTMSTID)">
							<el-image style="width: 100%;" :src="item.MDQMLINK" fit="contain">
							</el-image>
						</div>
						<div class="carlinetext">
							<p>{{item.MDHNAME1}}</p>
						</div>
						<div class="carlinebox row f-b">
							<el-button :class="item.MDTTHOUR=='true'?'carlinetime timenormal':'carlinetime timenoact'"
								@click="clickpop(item.MDTMDHID,item.MDTMSTID,item.MDTTHOUR,item.MDTSHOUR,item.MDTNHOUR,item.MDTTRHUR,item.MDTJLIMT,item.MDTADDAY,item.MDQMLINK,0)"
								:disabled="item.MDTTHOUR=='true'?false:true">
								<p>3<span>h</span></p>
								<span>{{$t('carlinedetail.carline_17')}}</span>
							</el-button>
							<el-button :class="item.MDTSHOUR=='true'?'carlinetime timenormal':'carlinetime timenoact'"
								@click="clickpop(item.MDTMDHID,item.MDTMSTID,item.MDTTHOUR,item.MDTSHOUR,item.MDTNHOUR,item.MDTTRHUR,item.MDTJLIMT,item.MDTADDAY,item.MDQMLINK,1)"
								:disabled="item.MDTSHOUR=='true'?false:true">
								<p>6<span>h</span></p>
								<span>{{$t('carlinedetail.carline_17')}}</span>
							</el-button>
							<el-button :class="item.MDTNHOUR=='true'?'carlinetime timenormal':'carlinetime timenoact'"
								@click="clickpop(item.MDTMDHID,item.MDTMSTID,item.MDTTHOUR,item.MDTSHOUR,item.MDTNHOUR,item.MDTTRHUR,item.MDTJLIMT,item.MDTADDAY,item.MDQMLINK,2)"
								:disabled="item.MDTNHOUR=='true'?false:true">
								<p>9<span>h</span></p>
								<span>{{$t('carlinedetail.carline_17')}}</span>
							</el-button>
							<el-button :class="item.MDTTRHUR=='true'?'carlinetime timenormal':'carlinetime timenoact'"
								disabled
								@click="clickpop(item.MDTMDHID,item.MDTMSTID,item.MDTTHOUR,item.MDTSHOUR,item.MDTNHOUR,item.MDTTRHUR,item.MDTJLIMT,item.MDTADDAY,item.MDQMLINK,3)"
								:disabled="item.MDTTRHUR=='true'?false:true">
								<p>24<span>h</span></p>
								<span>{{$t('carlinedetail.carline_17')}}</span>
							</el-button>
						</div>
						<div class="carenter row f-b" @click="CarLineDetail(item.MDTMDHID,item.MDTMSTID)">
							<span>{{$t('carline.carline_3')}}</span>
							<img src="@/assets/default/enter.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 未登录时弹窗 -->
		<div class="carlogin" v-show="popshow">
			<div class="carloginitem">
				<img src="@/assets/default/close.png" alt="" @click="popshow=false">
				<div class="carloginlist">
					<el-image style="" :src="loginpic" fit="contain"></el-image>
					<p></p>
					<div class="carloginbox orangebg row f-b" @click="toLogin">
						<p @click="toLogin">{{$t('carlinedetail.carline_16')}}</p>
						<img src="@/assets/default/calendatJT.png" alt="">
					</div>
					<div class="carloginbox whitebg row f-b" @click="ReserveCar()">
						<p>{{$t('carlinedetail.carline_15')}}</p>
						<img src="@/assets/default/enter.png" alt="">
					</div>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="showLogin" :close-on-click-modal='false' width="40%" class="login">
			<login @resetPassword='resetPassword' @register="register" @loginSubmit="loginSubmit"></login>
		</el-dialog>
	</div>
</template>


<script>
	// @ is an alias to /src

	import login from './Login.vue'

	export default {
		name: 'HomeView',
		components: {

		},
		data() {
			return {
				popshow: false,
				time: '',
				titleTime: '', //页面显示时间 2022.2.2
				curTime: '', //原本时间 2022-2-2
				showLogin: false,
				timedata: '',
				carlist: [],
				tid: '',
				carid: '',
				typelist: [],
				three: '',
				six: '',
				nine: '',
				ersi: '',
				personnum: '',
				addday: '',
				loginpic: '',
				weekday:''
			};
		},
		components: {
			login
		},
		watch: {},
		computed: {
			scrollerHeight: function() {

				return (window.innerHeight - 200) + 'px';

			}
		},
		methods: {
			Get_Car() {
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				}
				else if (this.$i18n.locale == 'zh') {
					this.lang = 1
				}
				else if (this.$i18n.locale == 'en') {
					this.lang = 2
				}
				this.$api.post(this.$config.Get_Car, {
						'sDate': this.curTime,
						'sWeekday':this.weekday,
						'sLNGCT': this.lang,
					},
					// 请求成功
					success => {
						console.log(success)
						this.carlist = success.KKDT
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},
			GET_INI_LIST() {
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				}
				else if (this.$i18n.locale == 'zh') {
					this.lang = 1
				}
				else if (this.$i18n.locale == 'en') {
					this.lang = 2
				}
				// 3/6/9/24/1
				this.$api.post(this.$config.GET_INI_LIST, {
						'sCOMID': '000',
						'sLNGCT': this.lang,
						'sKEY01': '10166'
					},
					// 请求成功
					success => {
						this.typelist = success.KKDT
						console.log(this.typelist)
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},
			CarLineDetail(tid, carid) {
				// this.$router.push('/CarLineDetail')
				this.$router.push({
					name: 'CarLineDetail',
					query: {
						// types: this.time + 'h（¥18,000）',
						// tid: tid,
						carid: tid,
						// timedata: this.timedata,
						curTime: this.curTime,
						weekday:this.weekday,
						// titleTime: this.titleTime
					} // 要传递的参数
				})
			},

			ReserveCar() {
				// this.$router.push('/ReserveCar')
				console.log(this.time)
				this.$router.push({
					path: 'ReserveCar',
					query: {
						linecarid: this.tid,
						curTime: this.curTime,
						weekday:this.weekday,
						// types: this.time,
						// three: this.three,
						// six: this.six,
						// nine: this.nine,
						// ersi: this.ersi,
						// personnum: this.personnum,
						// addday: this.addday,
					} // 要传递的参数
				})

				let flag = 0;
				if (this.addday.toString() == 'false') {
					flag = '1' //禁用
				}


				let carform = {
					types: this.time,
					three: this.three,
					six: this.six,
					nine: this.nine,
					ersi: this.ersi,
					personnum: this.personnum,
					addday: this.addday,
					dayflag: flag
				}
				// console.log(carform);
				// return
				sessionStorage.setItem("carform", JSON.stringify(carform));
			},
			clickpop(tid, carid, three, six, nine, ersi, personnum, addday, loginpic, time) {
				console.log(tid)
				console.log(carid)
				console.log(time)
				this.three = three
				this.six = six
				this.nine = nine
				this.ersi = ersi
				this.personnum = personnum
				this.addday = addday
				this.time = time
				this.tid = tid
				this.carid = carid
				this.loginpic = loginpic
				if (sessionStorage.getItem("log_email")) {
					this.ReserveCar()
				} else(
					this.popshow = !this.popshow
				)

			},
			toLogin() {
				this.$parent.$refs["headview"].dialogLoginVisible = true;
				this.$parent.$refs["headview"].dialogResetVisible = false;

				this.$parent.$refs["headview"].dialogRegisterVisible = false;

				this.popshow = false;
			},
			resetPassword() {
				this.$parent.$refs["headview"].dialogResetVisible = true;
				this.$parent.$refs["headview"].dialogLoginVisible = false;

				this.$parent.$refs["headview"].dialogRegisterVisible = false;
				// this.showLogin=false;
				this.popshow = false;
			},
			register() {

				this.$parent.$refs["headview"].dialogResetVisible = false;
				this.$parent.$refs["headview"].dialogLoginVisible = false;

				this.$parent.$refs["headview"].dialogRegisterVisible = true;
				// this.showLogin=false;
				this.popshow = false;
			},

			loginSubmit() {
				// this.$parent.$refs["headview"].userid = '123';
				this.showLogin = false;
				this.popshow = false;
			}


		},
		created() {
			let CalendatTime = this.$route.query.curDate;
			this.curTime = this.$route.query.curDate;
			this.weekday = this.$route.query.weekday;
			// this.timedata = this.$route.query.timedata;
			this.titleTime = CalendatTime.replace('-', '.').replace('-', '.');

			this.Get_Car()
			this.GET_INI_LIST()
		},
		mounted() {

		}
	}
</script>
<style scoped>
	@media only screen and (min-width:680px) {

		.carbg,
		.carlineh {
			width: 80%;
			margin: 0 auto;
		}

		.carlinetitle {
			padding-top: 70px;
			font-size: 50px;
			/* font-weight: bold; */
		}

		.carlinelist {
			width: calc((100% - 78px) / 4);
			margin-right: 26px;
			margin-bottom: 50px;
			float: left
		}

		.carlinelist:nth-child(4n) {
			margin-right: 0;
		}

		.carlinetime p {
			font-size: 28px;
			height: 34px;
			line-height: 34px
		}

		.carlinetime p>span {
			font-size: 16px;
		}

		.carlinet {
			font-size: 12px;
			margin-bottom: 30px;
		}

		.carlinelist .el-image {
			height: 150px;
		}

		.carlinetext {
			height: 48px;
		}

		.carlinetext>p {
			font-size: 15px;
			line-height: 24px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}

		.carloginitem {
			width: 640px;
			margin: 0 auto;
			border-radius: 6px;
			background-color: #fff;
		}

		.carloginlist {
			padding: 40px 90px;
			width: 100%
		}

		.carloginlist .el-image {
			width: 460px;
			height: 274px;
			margin: 0;
		}

		.carloginbox {
			width: 56%;
			margin: 0 auto;
			height: 50px;
			line-height: 50px;
			padding: 0 10px;
			box-sizing: border-box;
			margin-bottom: 15px;
			cursor: pointer;
		}

		.carloginbox>p {
			width: calc(100% - 18px);
			font-size: 16px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		}

		.carenter {
			width: 100%;
			border: 1px solid #DDDDDD;
			border-radius: 6px;
			padding: 0 8px;
			box-sizing: border-box;
			height: 32px;
			line-height: 32px;
			font-size: 12px;
			cursor: pointer;
			margin-top: 20px;
		}
	}

	@media only screen and (max-width:680px) {

		.carbg,
		.carlineh {
			width: 100%;
			padding: 0 4%;
			box-sizing: border-box;
		}

		.carlinetitle {
			padding-top: 30px;
			font-size: 26px;
			/* font-weight: bold; */
		}

		.carlinelist {
			width: calc((100% - 16px) / 2);
			margin-right: 16px;
			margin-bottom: 26px;
			float: left
		}

		.carlinelist:nth-child(2n) {
			margin-right: 0;
		}

		.carlinetime {
			font-size: 10px;
		}

		.carlinetime p {
			font-size: 20px;
			height: 34px;
			line-height: 34px
		}

		.carlinetime p>span {
			font-size: 12px;
		}

		.carlinet {
			font-size: 12px;
			margin-bottom: 20px;
		}

		.carlinelist .el-image {
			height: 120px;
		}

		.carlinetext {
			height: 40px;
		}

		.carlinetext>p {
			font-size: 14px;
			line-height: 20px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}

		.carloginitem {
			width: 80%;
			margin: 0 auto;
			border-radius: 6px;
			background-color: #fff;
		}

		.carloginlist {
			padding: 40px 5%;
			width: 100%;
			box-sizing: border-box;
		}

		.carloginlist .el-image {
			width: 100%;
			margin: 0;
		}

		.carloginbox {
			width: 64%;
			margin: 0 auto;
			height: 50px;
			line-height: 50px;
			padding: 0 10px;
			box-sizing: border-box;
			margin-bottom: 15px;
			cursor: pointer;
		}

		.carloginbox>p {
			width: calc(100% - 18px);
			font-size: 14px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		}

		.carenter {
			width: 100%;
			border: 1px solid #DDDDDD;
			border-radius: 6px;
			padding: 0 8px;
			box-sizing: border-box;
			height: 32px;
			line-height: 32px;
			font-size: 12px;
			cursor: pointer;
			margin-top: 20px;
		}
	}

	@media only screen and (max-width:510px) {
		.carloginbox>p {
			font-size: 12px;
		}
	}
	@media only screen and (max-width:450px) {
		.carloginbox>p {
			font-size: 10px;
		}
	}
	@media only screen and (max-width:830px) and (min-width:680px) {
		.carenter {
			width: 100%;
			border: 1px solid #DDDDDD;
			border-radius: 6px;
			padding: 0 8px;
			box-sizing: border-box;
			height: 32px;
			line-height: 32px;
			font-size: 10px;
			cursor: pointer;
			margin-top: 20px;
		}
	}

	p {
		margin: 0
	}


	.carlinetitle>span {
		margin-right: 16px;
	}

	.carlineitem {
		width: 100%;
	}



	.carlinelist>img {
		width: 100%;
		height: 150px;
		display: block;
		margin-bottom: 5px;
	}

	.clearfix:after {
		content: ' ';
		display: block;
		clear: both;
		visibility: hidden;
		line-height: 0;
		height: 0;
	}


	.carlinebox {
		width: 100%;
		margin-top: 6px;
	}

	.carlinetime {
		width: calc((100% - 15px) / 4);
		border-radius: 6px;
		text-align: center;
		padding-top: 5px;
		padding-bottom: 6px;
		cursor: pointer
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.f-b {
		justify-content: space-between;
	}

	/* .carlinetime p {
		font-size: 28px;
		height: 34px;
		line-height: 34px
	}

	.carlinetime p>span {
		font-size: 16px;
	} */

	.timeactive {
		background-color: #FF9C00;
		color: #000;
	}

	.timenormal {
		background-color: #000;
		color: #fff;
	}

	.timenoact {
		background-color: #DDDDDD;
		color: #fff;
	}

	.cartimetext {
		font-size: 12px;
		color: #D10000;
		margin: 8px 0;
		height: 42px;
		line-height: 17px
	}


	.carenter>img {
		width: 14px;
		height: 14px;
		display: block;
		margin-top: 9px
	}

	.carlogin {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(221, 221, 221, 0.8000);
		overflow: hidden;
		display: flex;
		align-items: center;
		text-align: center;
		justify-content: center
	}



	.carloginitem>img {
		width: 22px;
		height: 48px;
		float: right;
		margin-right: 15px
	}

	.carloginlist>p {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		margin: 20px 0
	}


	.carloginbox>img {
		width: 14px;
		height: 14px;
		display: block;
		margin-top: 18px;
	}


	.orangebg {
		background: #FF9C00;
		color: #fff
	}

	.whitebg {
		background-color: #fff;
		border: 1px solid #ddd;
		color: #666;
	}


	/deep/ .login .el-dialog__body {

		background-color: #FE9C2C;
	}

	/deep/ .login .el-dialog__header {
		background-color: #FE9C2C;
	}

	/deep/ .login .el-icon-close:before {
		font-size: 20px;
		color: #000000;
	}

	/deep/ .el-button+.el-button {
		margin: 0;
		padding: 0
	}

	/deep/ .el-button {
		padding: 6px 0
	}

	/deep/ .el-button.is-disabled,
	.el-button.is-disabled:focus,
	.el-button.is-disabled:hover {
		background-color: #bbb;
		color: #fff;
	}
</style>
